<svg><use href="assets/images/ok-illustrations-sprite.svg#no-connection"></use></svg>

<div>
  <h3>Siden kunne ikke findes</h3>
  <p>Den side du leder efter er blevet flyttet eller er ikke længere tilgængelig.</p>
  <p>Tryk herunder for at komme til forsiden.</p>
  <button mat-raised-button type="button" routerLink="/">Til forsiden</button>
</div>
